module.exports = __webpack_public_path__ + "static/img/公司6.5a665cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司6.jpg
// module id = k5+m
// module chunks = 1